import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').required('This field is required'),
  role: Yup.string().required('This field is required'),
});
